// Status helpers shared across admin + customer UI

export const INTERNAL_STATUSES = [
  "UNDER REVIEW", "WAITING CUSTOMER INFORMATION", "APPROVED FOR RETURN", "WITH CUSTOMER",
  "IN SHIPPING TO IDEA", "RECEIVED IN STORE", "TESTING", "WAITING INTERNAL DECISION",
  "APPROVED FOR VENDOR", "IN SHIPPING TO VENDOR", "WITH VENDOR", "WAITING VENDOR DECISION",
  "CREDIT APPROVED", "REPLACEMENT APPROVED", "REPAIR APPROVED", "VENDOR REJECTED",
  "REPLACEMENT RECEIVED", "RETURNING TO CUSTOMER", "COMPLETED", "CLAIM REJECTED",
];

export const CUSTOMER_STATUSES = [
  "UNDER REVIEW", "APPROVED TO SEND", "ON THE WAY TO IDEA", "RECEIVED BY IDEA",
  "IN-STORE TESTING", "ON THE WAY TO SUPPLIER", "AWAITING SUPPLIER RESPONSE",
  "STORE CREDIT APPROVED", "REPLACEMENT APPROVED", "WARRANTY REPAIR APPROVED",
  "SUPPLIER REJECTED", "RECEIVED & READY TO COLLECT", "COMPLETED", "REJECTED",
];

// semantic color category per status
const CATEGORY = {
  processing: ["TESTING", "WAITING INTERNAL DECISION", "RECEIVED IN STORE", "IN SHIPPING TO IDEA",
    "IN SHIPPING TO VENDOR", "REPLACEMENT RECEIVED",
    "ON THE WAY TO IDEA", "RECEIVED BY IDEA", "IN-STORE TESTING", "ON THE WAY TO SUPPLIER"],
  waiting: ["UNDER REVIEW", "WAITING CUSTOMER INFORMATION", "WAITING VENDOR DECISION",
    "AWAITING SUPPLIER RESPONSE", "SUPPLIER DECISION"],
  with_vendor: ["APPROVED FOR VENDOR", "WITH VENDOR"],
  approved: ["APPROVED FOR RETURN", "WITH CUSTOMER", "CREDIT APPROVED", "REPLACEMENT APPROVED",
    "REPAIR APPROVED", "COMPLETED", "RETURNING TO CUSTOMER",
    "APPROVED TO SEND", "STORE CREDIT APPROVED", "WARRANTY REPAIR APPROVED", "RECEIVED & READY TO COLLECT"],
  rejected: ["VENDOR REJECTED", "CLAIM REJECTED", "SUPPLIER REJECTED", "REJECTED"],
};

export function statusCategory(status) {
  for (const [cat, list] of Object.entries(CATEGORY)) {
    if (list.includes(status)) return cat;
  }
  return "neutral";
}

export const CATEGORY_CLASSES = {
  processing: "bg-blue-50 text-blue-700 border-blue-200",
  waiting: "bg-amber-50 text-amber-700 border-amber-200",
  with_vendor: "bg-purple-50 text-purple-700 border-purple-200",
  approved: "bg-emerald-50 text-emerald-700 border-emerald-200",
  rejected: "bg-rose-50 text-rose-700 border-rose-200",
  neutral: "bg-slate-100 text-slate-700 border-slate-200",
};

export const CATEGORY_DOT = {
  processing: "bg-blue-600",
  waiting: "bg-amber-500",
  with_vendor: "bg-purple-600",
  approved: "bg-emerald-600",
  rejected: "bg-rose-600",
  neutral: "bg-slate-500",
};

export const VENDOR_DECISIONS = ["PENDING", "CREDIT APPROVED", "REPLACEMENT APPROVED", "REPAIR APPROVED", "REJECTED", "OTHER"];
export const CN_STATUSES = ["UNUSED", "PARTIALLY USED", "USED", "CANCELLED"];

export const REPLACEMENT_STATUSES = [
  "APPROVED FOR REPLACEMENT",
  "REPLACEMENT RECEIVED",
  "REPLACEMENT HANDED OVER TO CUSTOMER",
];

export const SUB_INV_CATEGORIES = ["OUT OF WARRANTY", "RMA APPROVED", "CUSTOMER INDUCED DAMAGE", "DEAD ON ARRIVAL", "OTHER", "SUPPLIER REJECTED"];

export function replacementBadgeClass(status) {
  return {
    "APPROVED FOR REPLACEMENT": "bg-orange-50 text-orange-700 border-orange-200",
    "REPLACEMENT RECEIVED": "bg-blue-50 text-blue-700 border-blue-200",
    "REPLACEMENT HANDED OVER TO CUSTOMER": "bg-emerald-50 text-emerald-700 border-emerald-200",
  }[status] || "bg-slate-100 text-slate-700 border-slate-200";
}

export function waitingColor(days, overdue, threshold = 14) {
  if (overdue || days > 30) return "text-rose-600";
  if (days >= threshold) return "text-orange-600";
  if (days >= 7) return "text-amber-600";
  return "text-emerald-600";
}
export const ROLES = ["SUPER_ADMIN", "WARRANTY_MANAGER", "WARRANTY_STAFF", "TECHNICIAN", "FINANCE", "VIEW_ONLY"];
export const PROBLEM_CATEGORIES = ["Not Working", "Intermittent Problem", "Physical Issue", "Performance Issue", "Overheating", "Display Issue", "Power Issue", "Other"];
export const SHIPMENT_DIRECTIONS = [
  { value: "CUSTOMER_TO_IDEA", label: "Customer → IDEA" },
  { value: "IDEA_TO_VENDOR", label: "IDEA → Vendor" },
  { value: "VENDOR_TO_IDEA", label: "Vendor → IDEA" },
  { value: "IDEA_TO_CUSTOMER", label: "IDEA → Customer" },
];

export function money(value, currency = "OMR") {
  if (value == null || value === "") return `${currency} 0.000`;
  const n = Number(value);
  return `${currency} ${n.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 3 })}`;
}

export function fmtDate(iso) {
  if (!iso) return "—";
  try {
    return new Date(iso).toLocaleDateString("en-GB", { day: "2-digit", month: "short", year: "numeric" });
  } catch { return iso; }
}

export function fmtDateTime(iso) {
  if (!iso) return "—";
  try {
    return new Date(iso).toLocaleString("en-GB", { day: "2-digit", month: "short", year: "numeric", hour: "2-digit", minute: "2-digit" });
  } catch { return iso; }
}
